"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Auth = require("base-shell/lib/providers/Auth");

var _Menu = require("material-ui-shell/lib/providers/Menu");

var _Theme = require("material-ui-shell/lib/providers/Theme");

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      backgroundColor: theme.palette.primary.dark,
      margin: 0,
      padding: 0
    },
    listItem: {
      color: theme.palette.primary.contrastText,
      cursor: 'pointer'
    },
    icon: {
      color: theme.palette.primary.contrastText,
      cursor: 'pointer'
    },
    toolbar: _extends({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar)
  };
});

var MenuHeader = function MenuHeader() {
  var _useAuth = (0, _Auth.useAuth)(),
      auth = _useAuth.auth;

  var _useAppTheme = (0, _Theme.useTheme)(),
      toggleThisTheme = _useAppTheme.toggleThisTheme,
      isDarkMode = _useAppTheme.isDarkMode,
      isRTL = _useAppTheme.isRTL;

  var menuContext = (0, _Menu.useMenu)();
  var authData = auth;
  var classes = useStyles();

  var _ref = menuContext || {},
      toggleThis = _ref.toggleThis,
      isDesktop = _ref.isDesktop,
      isMiniMode = _ref.isMiniMode,
      isMenuOpen = _ref.isMenuOpen,
      isMiniSwitchVisibility = _ref.isMiniSwitchVisibility,
      isAuthMenuOpen = _ref.isAuthMenuOpen;

  var isAuthenticated = auth.isAuthenticated;

  var AvatarConstructor = function AvatarConstructor(_ref2) {
    var src = _ref2.src,
        alt = _ref2.alt,
        avatar = _ref2.avatar;
    return /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, {
      onClick: function onClick() {
        return toggleThis('isAuthMenuOpen');
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      src: src,
      alt: alt
    }, " ", avatar, " "));
  };

  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    square: true,
    className: classes.paper
  }, isMiniMode && isAuthenticated && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/_react.default.createElement(_core.List, {
    className: (0, _clsx.default)(!isAuthenticated && classes.toolbar)
  }, !isMiniMode && /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.listItem
  }, isAuthenticated && (authData.photoURL ? AvatarConstructor({
    src: authData.photoURL,
    alt: "user"
  }) : AvatarConstructor({
    avatar: authData.displayName ? authData.displayName[0].toUpperCase() : /*#__PURE__*/_react.default.createElement(_icons.Person, null)
  })), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      toggleThisTheme('isDarkMode');
    }
  }, isDarkMode ? /*#__PURE__*/_react.default.createElement(_icons.BrightnessHigh, {
    classes: {
      root: classes.icon
    }
  }) : /*#__PURE__*/_react.default.createElement(_icons.Brightness4, {
    classes: {
      root: classes.icon
    }
  })), isDesktop && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isMiniSwitchVisibility && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      toggleThis('isMiniMode', true);
      toggleThis('isMenuOpen', false);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.ChromeReaderMode, {
    classes: {
      root: classes.icon
    }
  })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    onClick: function onClick() {
      toggleThis('isMenuOpen', false);
    }
  }, isRTL ? /*#__PURE__*/_react.default.createElement(_icons.ChevronRight, {
    classes: {
      root: classes.icon
    }
  }) : /*#__PURE__*/_react.default.createElement(_icons.ChevronLeft, {
    classes: {
      root: classes.icon
    }
  })), ' '))), isAuthenticated && /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    onClick: function onClick() {
      toggleThis('isAuthMenuOpen');
    }
  }, !isMenuOpen && isMiniMode && isDesktop && (authData.photoURL ? AvatarConstructor({
    src: authData.photoURL,
    alt: "user"
  }) : AvatarConstructor({
    avatar: authData.displayName ? authData.displayName[0].toUpperCase() : /*#__PURE__*/_react.default.createElement(_icons.Person, null)
  })), !isMiniMode && /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    classes: {
      primary: classes.listItem,
      secondary: classes.listItem
    },
    style: {
      marginLeft: !isMenuOpen && isDesktop && authData.photoURL ? 7 : undefined
    },
    primary: authData.displayName,
    secondary: authData.email
  }), isMenuOpen && /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, {
    onClick: function onClick() {
      toggleThis('isAuthMenuOpen');
    }
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, null, isAuthMenuOpen ? /*#__PURE__*/_react.default.createElement(_icons.ArrowDropUp, {
    classes: {
      root: classes.icon
    }
  }) : /*#__PURE__*/_react.default.createElement(_icons.ArrowDropDown, {
    classes: {
      root: classes.icon
    }
  }))))));
};

var _default = MenuHeader;
exports.default = _default;
module.exports = exports.default;